var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { getSiteLanguage, isSSR, isSEO } from '../helpers';
import { buildSentryOptions, getArtifact } from '../utils';
import { Translations } from '../i18next';
import { ViewerScriptEnvironment } from '../environment/ViewerScript';
import { createExperimentsFromEssentials } from '../experiments';
import { FlowAPI } from './Base';
var ViewerScriptFlowAPI = /** @class */ (function (_super) {
    __extends(ViewerScriptFlowAPI, _super);
    function ViewerScriptFlowAPI(_a) {
        var experimentsConfig = _a.experimentsConfig, platformServices = _a.platformServices, sentryConfig = _a.sentryConfig, wixAPI = _a.wixAPI, appData = _a.appData, translationsConfig = _a.translationsConfig, _b = _a.defaultTranslations, defaultTranslations = _b === void 0 ? null : _b, biLogger = _a.biLogger, projectName = _a.projectName, appName = _a.appName, prepopulatedData = _a.prepopulatedData, _c = _a.optionalDeps, createHttpClient = _c.createHttpClient, initI18n = _c.initI18n, createExperiments = _c.createExperiments, localeDistPath = _a.localeDistPath, shouldUseEssentials = _a.shouldUseEssentials, basePath = _a.basePath;
        var _this = _super.call(this, {
            httpClient: shouldUseEssentials
                ? platformServices === null || platformServices === void 0 ? void 0 : platformServices.essentials.httpClient : createHttpClient === null || createHttpClient === void 0 ? void 0 : createHttpClient({
                isSSR: isSSR(wixAPI),
                getAppToken: function () { var _a, _b, _c; return (_c = (_b = (_a = wixAPI.site).getAppToken) === null || _b === void 0 ? void 0 : _b.call(_a, appData.appDefinitionId)) !== null && _c !== void 0 ? _c : appData.instance; },
            }),
        }) || this;
        _this.essentials = platformServices === null || platformServices === void 0 ? void 0 : platformServices.essentials;
        _this.wixAPI = wixAPI;
        _this.appName = appName;
        _this.projectName = projectName;
        _this.prepopulatedData = prepopulatedData;
        _this.basePath = basePath;
        _this.environment = new ViewerScriptEnvironment({
            appData: appData,
            wixAPI: wixAPI,
        });
        var language = getSiteLanguage(wixAPI, _this.environment.isEditor);
        _this.localeDistPath = localeDistPath;
        // We set null and use typecasting for preserving current API in cased when functional is disabled by user.
        // In future we can change it to mocked implementation.
        _this.translations =
            (translationsConfig === null || translationsConfig === void 0 ? void 0 : translationsConfig.enabled) === false
                ? null
                : new Translations({
                    language: language,
                    defaultTranslations: defaultTranslations,
                    prefix: translationsConfig === null || translationsConfig === void 0 ? void 0 : translationsConfig.prefix,
                    availableLanguages: translationsConfig === null || translationsConfig === void 0 ? void 0 : translationsConfig.availableLanguages,
                    localeDistPath: localeDistPath,
                    initI18n: initI18n,
                });
        var platformBI = platformServices === null || platformServices === void 0 ? void 0 : platformServices.bi;
        // We set null and use typecasting for preserving current API in cased when functional is disabled by user.
        // In future we can change it to mocked implementation.
        _this.experiments = null;
        _this._experimentsPromise = null;
        if (experimentsConfig) {
            var experimentsContext = _this.environment.isViewer
                ? {
                    siteOwnerId: platformBI === null || platformBI === void 0 ? void 0 : platformBI.ownerId,
                    visitorId: platformBI === null || platformBI === void 0 ? void 0 : platformBI.visitorId,
                }
                : {
                    siteOwnerId: platformBI === null || platformBI === void 0 ? void 0 : platformBI.ownerId,
                    loggedInUserId: wixAPI.user.currentUser.id,
                };
            var experimentsOverrideCriteria = (platformBI === null || platformBI === void 0 ? void 0 : platformBI.metaSiteId) ? {
                entityId: platformBI === null || platformBI === void 0 ? void 0 : platformBI.metaSiteId,
            }
                : undefined;
            if (shouldUseEssentials) {
                _this._experimentsPromise =
                    experimentsConfig.centralized && !(prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.experiments)
                        ? Promise.resolve(_this.essentials.experiments)
                        : createExperimentsFromEssentials(_this.essentials.createExperiments, experimentsConfig, prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.experiments, experimentsContext, experimentsOverrideCriteria, _this.environment.isSSR ? 'https://wix.com' : undefined);
            }
            else {
                var experiments = createExperiments({
                    prepopulated: prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.experiments,
                    experimentsConfig: experimentsConfig,
                    baseUrl: _this.environment.isSSR ? 'https://wix.com' : undefined,
                    ctx: experimentsContext,
                    overrideCriteria: experimentsOverrideCriteria,
                });
                _this._experimentsPromise = experiments.init();
            }
        }
        if (prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.biLogger) {
            _this.bi = prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.biLogger;
        }
        else if (biLogger) {
            var biFactory = void 0;
            if (shouldUseEssentials) {
                biFactory = _this.essentials.biLoggerFactory();
            }
            else if (platformServices) {
                biFactory = platformServices.biLoggerFactory();
            }
            if (biFactory) {
                _this.bi = biLogger(biFactory)({});
            }
        }
        // flowAPI.sentry shouldn't be optional for users.
        // If user didn't configure sentry, then we'll still provide typed object.
        _this.sentry = null;
        _this.errorMonitor = null;
        if (prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.sentryMonitor) {
            _this.sentry = prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.sentryMonitor;
        }
        else if (prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.errorMonitor) {
            _this.errorMonitor = prepopulatedData === null || prepopulatedData === void 0 ? void 0 : prepopulatedData.errorMonitor;
        }
        else if (sentryConfig) {
            if (sentryConfig.errorMonitor && (platformServices === null || platformServices === void 0 ? void 0 : platformServices.essentials.createErrorMonitor)) {
                _this.errorMonitor = platformServices === null || platformServices === void 0 ? void 0 : platformServices.essentials.createErrorMonitor({
                    dsn: sentryConfig.DSN,
                    environment: 'Viewer:Worker',
                    version: getArtifact(),
                    tags: {
                        isSSR: isSSR(wixAPI),
                        isSEO: isSEO(wixAPI),
                    },
                });
            }
            else {
                var sentryOptions_1 = buildSentryOptions({
                    dsn: sentryConfig.DSN,
                    environment: 'Viewer:Worker',
                    artifact: getArtifact(),
                    withDataCallback: true,
                    tags: {
                        isSSR: isSSR(wixAPI),
                        isSEO: isSEO(wixAPI),
                    },
                });
                _this.sentry = platformServices === null || platformServices === void 0 ? void 0 : platformServices.monitoring.createMonitor(sentryOptions_1.dsn, function (config) { return (__assign(__assign({}, config), sentryOptions_1.config)); });
            }
        }
        if (_this.sentry) {
            _this.reportError = function (error) {
                if (typeof error === 'string') {
                    _this.sentry.captureMessage(error);
                }
                else {
                    _this.sentry.captureException(error);
                }
                return _this.sentry.lastEventId();
            };
        }
        if (_this.errorMonitor) {
            _this.reportError = function (error) {
                if (typeof error === 'string') {
                    return _this.errorMonitor.captureMessage(error);
                }
                return _this.errorMonitor.captureException(error);
            };
        }
        return _this;
    }
    ViewerScriptFlowAPI.prototype.init = function () {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        _c = this;
                        return [4 /*yield*/, this._experimentsPromise];
                    case 1:
                        _c.experiments = _d.sent();
                        return [4 /*yield*/, ((_a = this.translations) === null || _a === void 0 ? void 0 : _a.init({
                                prepopulated: (_b = this.prepopulatedData) === null || _b === void 0 ? void 0 : _b.translations,
                            }))];
                    case 2:
                        _d.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ViewerScriptFlowAPI.prototype.createTranslations = function (controllerDescriptor, optionalDeps, options) {
        var _a;
        var translationsConfig = controllerDescriptor.translationsConfig, defaultTranslations = controllerDescriptor.defaultTranslations, localeDistPath = controllerDescriptor.localeDistPath;
        if ((translationsConfig === null || translationsConfig === void 0 ? void 0 : translationsConfig.enabled) === false) {
            return null;
        }
        if (localeDistPath === this.localeDistPath &&
            (options === null || options === void 0 ? void 0 : options.basePath) === this.basePath) {
            return this.translations;
        }
        var language = getSiteLanguage(this.wixAPI, this.environment.isEditor);
        return new Translations({
            language: language,
            defaultTranslations: defaultTranslations,
            availableLanguages: translationsConfig === null || translationsConfig === void 0 ? void 0 : translationsConfig.availableLanguages,
            prefix: translationsConfig === null || translationsConfig === void 0 ? void 0 : translationsConfig.prefix,
            localeDistPath: localeDistPath,
            initI18n: optionalDeps === null || optionalDeps === void 0 ? void 0 : optionalDeps.initI18n,
            basePath: (_a = options === null || options === void 0 ? void 0 : options.basePath) !== null && _a !== void 0 ? _a : this.basePath,
        });
    };
    return ViewerScriptFlowAPI;
}(FlowAPI));
export { ViewerScriptFlowAPI };
//# sourceMappingURL=ViewerScript.js.map